var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 9,
    viewBox: "0 0 103 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.354 4.85355C102.549 4.65829 102.549 4.34171 102.354 4.14645L99.1716 0.964466C98.9763 0.769204 98.6597 0.769204 98.4645 0.964466C98.2692 1.15973 98.2692 1.47631 98.4645 1.67157L101.293 4.5L98.4645 7.32843C98.2692 7.52369 98.2692 7.84027 98.4645 8.03553C98.6597 8.2308 98.9763 8.2308 99.1716 8.03553L102.354 4.85355ZM0 5H102V4H0V5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/vector-icon.b63a71e017b7fe818808c95c336c843e.svg";
export { ForwardRef as ReactComponent };